module.exports = __webpack_public_path__ + "static/media/macacaoOnMobile.9df44ac7.jpg";